import axios from '../axiosConfig';

const parseLeads = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.leads)) return payload.leads;
  return [];
};

const parseLead = (payload) => payload?.lead || payload || null;

export const listLeads = async (params = {}) => {
  const response = await axios.get('/leads', { params });
  return parseLeads(response?.data);
};

export const getLead = async (id) => {
  const response = await axios.get(`/leads/${id}`);
  return parseLead(response?.data);
};

export const updateLeadStatus = async (id, status) => {
  const response = await axios.patch(`/leads/${id}`, {
    lead: { status },
  });

  return parseLead(response?.data) || { id, status };
};
